import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import { DateTime } from 'luxon';
import * as fromSelectors from '../../store/sales-appointment/sales-appointment.selectors';
import { take } from 'rxjs/operators';
import * as fromActions from '../../store/sales-appointment/sales-appointment.actions';
import {  SalesAppointmentState } from '../../store/sales-appointment/sales-appointment.reducer';
import { Store } from '@ngrx/store';
import { SearchCustomersState } from '../../store/search-customers/search-customers.reducer';
import { selectCurrentCustomer } from '../../store/search-customers/search-customers.selectors';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { SubscriptionList } from '../../shared/models/asp.types';
import { ICustomer } from '@signal/asp-data-commons/lib/interfaces/appointment';
import { AppointmentBookingSource, AppointmentType } from '@signal/asp-data-commons/lib/enums/enum';
import { confirmConfig, unsubscribeSubscriptions } from '../../shared/services/util.service';
import { AspBannerService } from '../../shared/services/asp-banner.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { SettingsState } from '../../store/settings/settings.reducer';
import { LoadSettings } from '../../store/settings/settings.actions';
import _ from 'lodash';
import { SelectLearningVehicleComponent } from '../shared/select-learning-vehicle/select-learning-vehicle.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { TradeInInfoComponent } from '../shared/trade-in-info/trade-in-info.component';
import { AvailabilityComponent } from '../../shared/components/availability/availability.component';
import { IGeneralSettingsAppointmentRequest } from '@signal/asp-data-commons';
import * as fromSettingsSelectors from "../../store/settings/settings.selectors";
import { CustomerType } from '../../shared/enums/customer-types.enum';

@Component({
  selector: 'app-tech-appointment',
  templateUrl: './tech-appointment.component.html',
  styleUrls: ['./tech-appointment.component.scss']
})
export class TechAppointmentComponent implements OnInit, OnDestroy, AfterViewInit {
  techAppointmentForm: UntypedFormGroup;
  availability: UntypedFormControl;
  tradeInForm: UntypedFormControl;
  availabilityOptions$: any;
  availabilityOptionsLoading$: any;
  availability$: any;
  availabilityLoading$: any;
  transportOptions$: any;
  remoteZipcodes$: Observable<string[]>;
  yearList$: any;
  isUpdate: boolean =  false;
  showMandatoryMsgCI:boolean = false;
  hasRemoteLocation: boolean =  false;
  remoteValidZipcodes: { pmaZipCodes: string[], isRemote: boolean };
  isValidRemoteZip = false;
  transport: any;
  subscriptions: SubscriptionList = {};
  private customerForm: UntypedFormControl;
  private contactEmailInfoForm: UntypedFormControl;
  customerDetails$: Observable<ICustomer>;
  private signedInUserDetails: ICustomer;
  isSubmitting = false;
  appointmentId: string;
  lastValue;
  editBool:boolean = false;
  oldValue: any;
  dateFormat : string = 'yyyy-MM-dd';
  apptType: string = AppointmentType.LEARNING;
  valueChanged=true;
  isStoreUpdate = true;
  allowed = false;
  languageId='';
  customerDataOnEdit;
  @ViewChild(SelectLearningVehicleComponent, { static: false }) selectVehicleComponent: SelectLearningVehicleComponent;
  @ViewChild(TradeInInfoComponent, { static: false }) tradeInInfoComponent: TradeInInfoComponent;
  @ViewChild(AvailabilityComponent, { static: false }) AvailabilityComponent: AvailabilityComponent;
  settings:IGeneralSettingsAppointmentRequest={} as IGeneralSettingsAppointmentRequest;
  signalDeeplinkId="";
  firstTimeDL = true;
  src="";
  vehicleInfo={};
  
  constructor(
    private readonly dialog: MatDialog,
    private readonly salesAppointmentState: Store<SalesAppointmentState>,
    private bannerService: AspBannerService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly searchCustomersState: Store<SearchCustomersState>,
    private readonly router: Router,
    private route: ActivatedRoute,
    private readonly settingsState: Store<SettingsState>,
    private readonly translateService:TranslateService,
    private readonly cdr: ChangeDetectorRef  ) { 
    this.settingsState.dispatch(new LoadSettings({department: 'sales'}));
    this.initTechForm();

    /* logic to edit appointment */
  this.subscriptions.params = this.route.queryParams.subscribe(params => {
    if (params.src === "signal" && params.id) {
      this.signalDeeplinkId = params.id;
      this.src = params.src;
    } else {
      this.appointmentId = params.id;
      if (this.appointmentId) {
        this.editBool = true;
        this.salesAppointmentState.dispatch(new fromActions.GetEditData
          ({ appointmentType: AppointmentType.LEARNING, appointmentId: this.appointmentId }));
          /// check why the drvaFlag related data is missing in the customerDataOnEdit from store
        this.subscriptions.appointmentDetails = this.salesAppointmentState.select(fromSelectors.appointmentDetails).subscribe((value) => {
          if (_.isEqual(this.lastValue, value)) {
            return;
          }
          this.lastValue = value;
          this.languageId = value?.availability?.languageId;
          if (!this.customerDataOnEdit?.firstName) {
            this.customerDataOnEdit = value.customer;
          }
          let updatedValue = {...value}
          if(this.customerDataOnEdit.drvaFlag){
            updatedValue = {
              ...value,
              customer: {
                ...value.customer,
                emailAddress : '',
                phoneNumber: ' '
              }
            }
          }
          this.techAppointmentForm.patchValue(updatedValue);
        })

      }
    }
  });
    /** this.salesAppointmentState.dispatch(new fromActions.LoadSeriesAndTrim()); */
    this.salesAppointmentState.dispatch(new fromActions.LoadAvailabilityOptions({appointmentType:AppointmentType.LEARNING}));
         
  }
  canExit():Observable<boolean> { 
    let dialogRef;
    const result = new Subject<boolean>();
      dialogRef = this.dialog.open(ConfirmDialogComponent, confirmConfig);
      this.subscriptions.dialogRef = dialogRef.afterClosed().subscribe(event => {
        if (event.action === 'confirm') { }
        else if(event.action === 'close'){
          result.next(true);
          result.complete();
         }
    });
  return result.asObservable(); 
  };

  // returns if the forms are edited
  formsNotEdited()
  {
    return this.valueChanged;
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  valuesChange(event)
  {
    this.valueChanged=event;
  }

  ngOnInit(): void {
    this.bannerService.update('');
    this.bannerService.show();
    this.setSignedInUserDetails();

    this.availabilityOptions$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityOptions);
    this.availabilityOptionsLoading$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityOptionsLoading);
    this.availabilityLoading$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityLoading);
    this.availability$ = this.salesAppointmentState.select(fromSelectors.getAvailability);
    this.transportOptions$ = this.salesAppointmentState.select(fromSelectors.getTransportOptions);
    this.remoteZipcodes$ = this.salesAppointmentState.select(fromSelectors.getPMAZipCodes);
    this.yearList$ = this.salesAppointmentState.select(fromSelectors.getYearList);
    this.subscriptions.generalSettings=this.settingsState.select(fromSettingsSelectors.selectSettings).subscribe(settings => {
      if(settings && Object.entries(settings).length)
      {
        this.settings.time=settings.time;
        this.settings.portal=settings.portal;
        this.settings.dealerInfo=settings.dealerInfo;
        this.settings.isAspCrmIntegrationEnabled=settings.isAspCrmIntegrationEnabled;
        this.settings.isAspDmsIntegrationEnabled=settings.isAspDmsIntegrationEnabled;
        this.settings.isConsumerPortalEnabled=settings.isConsumerPortalEnabled;
        this.settings.isServiceAccessible=settings.isServiceAccessible;
      }
    });
    if(!this.editBool){
      this.subscriptions.appointmentDetails = this.salesAppointmentState.select(fromSelectors.appointmentDetails).subscribe((value) =>{
      
        if (_.isEqual(this.lastValue, value)) {
          this.isStoreUpdate = true;
          return;
        }
        this.lastValue = value;
        
        if(this.signalDeeplinkId) {
          this.vehicleInfo = this.lastValue?.vehicle;
        }
        this.techAppointmentForm.patchValue(value);
      })
    }
    setTimeout(() => {
      if (this.firstTimeDL && this.signalDeeplinkId) {
        this.firstTimeDL = false;
        this.salesAppointmentState.dispatch(
          new fromActions.LoadSalesAppointmentFromSignalDeepLink({ signalDeeplinkId: this.signalDeeplinkId }));
      }
    }, 0);
  }
  
  initTechForm(){
    
    this.techAppointmentForm = this.formBuilder.group({
      transportationTypeCode: ['DEALER'],
      remoteZipCode: [''],
      availability: this.availability,
      customer: this.contactEmailInfoForm,
      tradeIn: this.tradeInForm
    });
    this.subscriptions.formChanges = this.techAppointmentForm.valueChanges.subscribe((data)=>{
      this.onValueChange();
    })
  }

  onValueChange() {
   const value = _.cloneDeep(this.techAppointmentForm?.value);
  this.isStoreUpdate = false;
  if(this.checkOldValue(value)){
    this.isStoreUpdate = true;
    return;
  }
  if((value.availability?.advisorId && this.oldValue.availability?.advisorId !== value.availability.advisorId)
  || (value.transportationTypeCode && this.oldValue?.transportationTypeCode && this.oldValue?.transportationTypeCode !== value.transportationTypeCode)) {
    if (value.availability.appointmentStartDate) {
      const date = DateTime.fromFormat(value.availability.appointmentStartDate, this.dateFormat)
        .startOf('month')
        .toFormat(this.dateFormat);
      this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
        {selectDateAndSlot: true, date, advisorId: value.availability.advisorId, transport: value.transportationTypeCode, vin:'',
        appointmentType: AppointmentType.LEARNING,appointmentId:this.appointmentId ? this.appointmentId : ''}));
    }
    else{
      const advisor =value.availability.advisorId ? value.availability.advisorId : '-1';
      this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
        {selectDateAndSlot: false, date: '', advisorId: advisor, transport: value.transportationTypeCode, vin:'',
        appointmentType: AppointmentType.LEARNING,appointmentId:this.appointmentId ? this.appointmentId : ''}));
    }
  }
  this.oldValue = value;

  this.toCheckAllowOnEditMode();

  if (value?.customer?.emailAddress) {
    value.customer.emailAddress = value.customer.emailAddress.trim();
  }
  
  if(this.allowed && !this.isStoreUpdate){
    this.isStoreUpdate = true;
    this.lastValue={...this.lastValue, ...value};
    this.salesAppointmentState.dispatch(new fromActions.UpdateSalesFormData({ value, appointmentType: AppointmentType.LEARNING }));
  }
}
isCIformValid(event) {
  this.showMandatoryMsgCI = event;
}

toCheckAllowOnEditMode() {
  /**in editmode when form value will be loaded perfectly then it will be allowed to update the state. It will look for this change onetime, next time onward form will detect changes accordingly. */
  if(this.editBool && !this.allowed) {
    if(this.isValidForm()) {
      this.allowed = true;
    }
  }
  /** normal flow, this form will be allowed to do the changes anytime. */
  if(!this.editBool) {
    this.allowed = true;
  }
}

  checkOldValue(newValue) {
    return _.isEqual(this.oldValue, newValue);
  }
  
  setSignedInUserDetails() {
    this.customerDetails$ = this.searchCustomersState.select(selectCurrentCustomer);
    this.subscriptions.customerSub = this.customerDetails$
      .subscribe(customer => {
        this.signedInUserDetails = {
          firstName: customer?.firstName || '',
          lastName: customer?.lastName || '',
          emailAddress: !customer?.drvaFlag ? customer?.emailAddress : '',
          phoneNumber: !customer?.drvaFlag ? customer?.phoneNumber : ' ',
          customerType: customer?.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
          businessName: customer?.businessName || '',
          drvaFlag: customer?.drvaFlag || false
          //customerType: customer?.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
        //  businessName: customer?.businessName || ''
        };
        this.techAppointmentForm.patchValue({customer: this.signedInUserDetails});
        this.salesAppointmentState.dispatch(new fromActions.LoadCustomerDetails({ signedInUserDetails: this.signedInUserDetails }));
      });

  }

  getSignedInUserDetails() {
    return this.signedInUserDetails;
  }

  get getDisclaimerText() {
    return this.translateService.instant('testDrive.privacyPolicyTxt');
  }

  getTranslation(value){
    return value ? `${this.translateService.instant(`common.${value}`)}` : value;
  }

  onSubmit() {
    this.isSubmitting = true;
    this.valueChanged=true;
    this.onValueChange();
    const payload = {appointmentType : AppointmentType.LEARNING,settings:this.settings}
    if(this.editBool){
      this.salesAppointmentState.dispatch(new fromActions.EditSalesAppointment(payload));
    }
    else{
      if(this.src === "signal") {
        payload["requestAppSrc"] = AppointmentBookingSource.SIGNAL_CTA;
      }
      this.salesAppointmentState.dispatch(new fromActions.CreateSalesAppointment(payload));
    }
    this.subscriptions.editDetail = this.salesAppointmentState.select(fromSelectors.editDetails)
      .subscribe((editDetail) => {
        this.onSubmitting(editDetail);
      });
  }

  onSubmitting(data) {
        if(data){
          this.isSubmitting = data.isSubmitted;
          if (data.isSubmitted) {
            const urlState = {...data.appointmentData};   
            const navigationExtras: NavigationExtras = {
              queryParams: {
                id: data.appointmentId
              },
              state: urlState
            };
            this.router.navigate(['asp/bdc/tech-appointment/confirm'], navigationExtras);
          }
        }
  }

  isValidForm() {
    const vehicle = {...this.selectVehicleComponent?.step?.value};
    const apptStartDate = this.techAppointmentForm.get('availability').value?.appointmentStartDate || "";
    const currentDate = DateTime.fromISO(DateTime.now().toString())
    .toFormat(this.dateFormat);
    return this.techAppointmentForm.valid && this.checkVehicleValues(vehicle) && apptStartDate>=currentDate;
  }

  checkVehicleValues(vehicle){
    if (Object.keys(vehicle).length === 0) {
      return false;
    }
    if(vehicle.make !== "" && vehicle.model !== "" && vehicle.year !== ""){
      return true;
    }
    else if(vehicle.vin?.length === 17){
      return true;
    }
    return false;
  }

  onMonthChange($event: any) {
    this.subscriptions.availability = this.salesAppointmentState.select(fromSelectors.getAvailabilityDetails)
       .pipe(take(1))
       .subscribe(details => {
        const date = $event.toFormat(this.dateFormat);
         this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
           {selectDateAndSlot: false, date, advisorId: details.advisorId, transport: details.transport, vin:'',
           appointmentType: AppointmentType.LEARNING ,appointmentId:this.appointmentId ? this.appointmentId : ''}));
       });
  }

  backToDashboard() {
    this.router.navigate(['asp/bdc/dashboard']);
  }
  
  ngOnDestroy() {
    unsubscribeSubscriptions(this.subscriptions);
    this.salesAppointmentState.dispatch(new fromActions.ResetSalesAppointmentState());
    this.bannerService.update('');
    this.cdr.detach();
  }

}
